import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { submit, isValid, getFormValues } from 'redux-form';

import { Main } from 'Containers';
import ReactTable from 'Common/ReactTableWrapper';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { YesNoDialog } from 'Components/';
import { TaxRateFieldEnum } from 'Common/FieldEnum';
import { createToast, toastType, errorToast } from 'Common/ToastHelper';
import { StatusEnum } from 'Common/Constants/Enumeration/StatusEnum';
import {
  TAX_RATE_ENTRY_FORM_NAME,
  ASSIGN_TAX_SITES_FORM_NAME,
} from 'Common/FormEnum';

import TaxRateModal from './TaxRateModal';
import * as Actions from '../../state/taxRates/actions';
import * as selectors from '../../state/taxRates/selectors';
import { AssignSitesModal } from './AssignSitesModal';

class TaxRateSetupComponent extends Component {
  state = {
    data: null,
    error: false,
    loading: false,
    isCreateModalOpen: false,
    isDeleteModalOpen: false,
    showAssignSitesModal: false,
    showCloseConfirmation: false,
    showAssignSitesDialog: false,
    assignSitesModalOpenedFromTaxRateModal: false,
    alreadyAssignedSites: [],
  };

  menuOptions = [
    {
      icon: 'pencil',
      text: 'Edit',
      handler: (rowData) => this.openCreateModal(rowData),
    },
    {
      icon: 'signup',
      text: 'Assign Sites',
      handler: (rowdata) => this.openAssignSitesModal(rowdata),
    },
    {
      icon: 'trash',
      text: 'Delete',
      className: 'danger',
      handler: (rowData) => this.openDeleteModal(rowData),
    },
  ];

  columns = [
    {
      Header: 'Name',
      accessor: TaxRateFieldEnum.Name,
      filterable: false,
      resizable: false,
    },
    {
      Header: 'Free',
      accessor: TaxRateFieldEnum.Free,
      filterable: false,
      resizable: false,
      style: { textAlign: 'right' },
    },
    {
      Header: 'Reduced',
      accessor: TaxRateFieldEnum.Reduced,
      filterable: false,
      resizable: false,
      style: { textAlign: 'right' },
    },
    {
      Header: 'Paid',
      accessor: TaxRateFieldEnum.Paid,
      filterable: false,
      resizable: false,
      style: { textAlign: 'right' },
    },
    {
      Header: 'Teacher',
      accessor: TaxRateFieldEnum.Teacher,
      filterable: false,
      resizable: false,
      style: { textAlign: 'right' },
    },
    {
      Header: 'Adult',
      accessor: TaxRateFieldEnum.Adult,
      filterable: false,
      resizable: false,
      style: { textAlign: 'right' },
    },
    {
      Header: 'School Food Service',
      accessor: TaxRateFieldEnum.SchoolFoodService,
      width: 150,
      filterable: false,
      resizable: false,
      style: { textAlign: 'right' },
    },
    {
      Header: 'Catering',
      accessor: TaxRateFieldEnum.Catering,
      filterable: false,
      resizable: false,
      style: { textAlign: 'right' },
    },
    {
      Header: '',
      id: 'menu',
      width: 50,
      sortable: false,
      resizable: false,
      style: { textAlign: 'center' },
      Cell: (gridProps) =>
        GridContextMenu({ gridProps, options: this.menuOptions }),
    },
  ];

  componentDidMount() {
    const { onRef, getTaxRates } = this.props;

    onRef(this);
    getTaxRates();
  }
  componentWillUnmount() {
    const { onRef } = this.props;

    onRef(undefined);
  }

  componentDidUpdate(prevProps) {
    const {
      taxRateSaveSitesSuccessful,
      setSaveSitesSuccessful,
      setSaveSuccessful,
      taxRateSaveSuccessful,
      deleteSuccessful,
      setDeleteSuccessful,
      clearErrors,
      getTaxRates,
    } = this.props;

    const { assignSitesModalOpenedFromTaxRateModal, selectedRow } = this.state;

    if (!prevProps.taxRateSaveSitesSuccessful && taxRateSaveSitesSuccessful) {
      createToast(toastType.success, 'Success', 'Tax Rates Assigned to Sites');
      setSaveSitesSuccessful(false);
      getTaxRates();
      this.setState({ showAssignSitesModal: false });
    }

    if (!prevProps.taxRateSaveSuccessful && taxRateSaveSuccessful) {
      createToast(toastType.success, 'Success', 'Tax Rate Saved Successfully');
      setSaveSuccessful(false);
      this.closeCreateModal();
      if (assignSitesModalOpenedFromTaxRateModal) {
        this.openAssignSitesModal(selectedRow);
      }
    }

    if (!prevProps.deleteSuccessful && deleteSuccessful) {
      createToast(toastType.success, 'Success', 'Tax Rate Deleted');
      setDeleteSuccessful(false);
    }

    if (
      errorToast(this.props, prevProps, 'getSitesError') ||
      errorToast(this.props, prevProps, 'saveSitesError') ||
      errorToast(this.props, 'error')
    ) {
      clearErrors();
    }
  }

  openCreateModal = (row = {}) => {
    this.setState({ selectedRow: row, isCreateModalOpen: true });
  };

  openAssignSitesModal = (row) => {
    this.setState({ selectedRow: row, showAssignSitesModal: true });
  };

  closeAssignSitesModal = (isDirty) => {
    if (isDirty) {
      this.setState({ showCloseConfirmation: true });
      return;
    }
    this.setState({
      showAssignSitesModal: false,
      selectedRow: null,
      assignSitesModalOpenedFromTaxRateModal: false,
    });
  };

  handleAssignSitesBackClick = (isDirty) => {
    const { assignSitesModalOpenedFromTaxRateModal, selectedRow } = this.state;
    const { data } = this.props;
    if (isDirty) {
      this.setState({ showCloseConfirmation: true });
      return;
    }

    if (assignSitesModalOpenedFromTaxRateModal) {
      this.setState({
        showAssignSitesModal: false,
        assignSitesModalOpenedFromTaxRateModal: false,
      });

      //if created new tax rate then we need to get the row from the data the back end has returned so that it has the generated Id
      const newSelectedRow = data.find((x) => x.Name === selectedRow.Name);

      this.openCreateModal(newSelectedRow);
    } else {
      this.setState({ showAssignSitesModal: false });
    }
  };

  closeCreateModal = (isDirty) => {
    if (isDirty) {
      this.setState({
        showCloseConfirmation: true,
        assignSitesModalOpenedFromTaxRateModal: false,
      });
      return;
    }

    this.setState({ isCreateModalOpen: false });
  };

  handleUnSavedChangesDialogNoClick = () => {
    this.setState({ showCloseConfirmation: false });
  };

  handleUnSavedChangesDialogYesClick = () => {
    this.setState({ showCloseConfirmation: false });
    this.closeCreateModal(false);
    this.closeAssignSitesModal(false);
  };

  openDeleteModal = (row) => {
    this.setState({ selectedRow: row, isDeleteModalOpen: true });
  };

  closeDeleteModal = () => {
    this.setState({ isDeleteModalOpen: false });
  };

  handleSubmit = (rowData) => {
    const model = {
      Name: rowData.Name,
      Id: rowData.Id,
      StatusesAndRates: Object.keys(rowData)
        .filter((x) => x !== 'Name' && x !== 'Id' && x !== 'Sites')
        .map((key) => {
          return { Status: StatusEnum[key], Rate: rowData[key] };
        }),
    };

    this.setState({ selectedRow: rowData });
    this.props.saveTaxRate(model);
  };

  handleAssignSitesSubmit = (sitesArray) => {
    const { data } = this.props;
    const { selectedRow } = this.state;

    const taxRatesOtherThanSelected = data.filter(
      (x) => x.Id !== selectedRow.Id
    );

    const alreadyAppliedForOtherRate = [];

    taxRatesOtherThanSelected.forEach((taxRate) =>
      taxRate.Sites.forEach((site) => {
        if (sitesArray.Sites.includes(site)) {
          alreadyAppliedForOtherRate.push(site);
        }
      })
    );

    if (alreadyAppliedForOtherRate.length > 0) {
      this.setState({
        showAssignSitesDialog: true,
        alreadyAssignedSites: alreadyAppliedForOtherRate,
      });
    } else {
      this.saveAssignSites();
    }
  };

  saveAssignSites = () => {
    const { selectedRow } = this.state;
    const { saveTaxRateSites, assignSitesFormValues } = this.props;
    saveTaxRateSites({
      SiteIds: assignSitesFormValues.Sites,
      TaxRateId: selectedRow.Id,
    });
  };

  handleDelete = (rowData) => {
    this.props.deleteTaxRate(rowData[TaxRateFieldEnum.Id]);
    this.closeDeleteModal();
  };

  handleSaveAndAssignSitesClick = () => {
    const { isTaxRateFormValid } = this.props;

    this.props.submit(TAX_RATE_ENTRY_FORM_NAME);

    if (isTaxRateFormValid) {
      this.setState({ assignSitesModalOpenedFromTaxRateModal: true });
    }
  };

  handleAssignSitesDialogYesClick = () => {
    this.saveAssignSites();
    this.setState({ showAssignSitesDialog: false });
  };

  handleAssignSitesDialogNoClick = () => {
    this.setState({ showAssignSitesDialog: false });
  };

  render() {
    const { data, loading, usedTaxRateNames } = this.props;

    const {
      selectedRow,
      isCreateModalOpen,
      isDeleteModalOpen,
      showAssignSitesModal,
      showCloseConfirmation,
      showAssignSitesDialog,
      alreadyAssignedSites,
    } = this.state;

    const deleteTaxRateWithSitesQuestion = `Are you sure you want to delete this Tax Rate: ${
      selectedRow && selectedRow.Name
    }? This will unapply the tax rate from these sites: ${
      selectedRow ? selectedRow.Sites : ''
    }`;

    const deleteTaxRateWithoutSitesQuestion = `Are you sure you want to delete this Tax Rate: ${
      selectedRow && selectedRow.Name
    }?`;

    return (
      <Fragment>
        <Main>
          <ReactTable
            data={data || []}
            className="-striped -highlight grid--fixed-row-height"
            loading={loading}
            columns={this.columns}
            menu="hasCogs"
            minRows={5}
            noDataText="No rows found"
          />
          <TaxRateModal
            rowData={selectedRow}
            isOpen={isCreateModalOpen}
            onClose={this.closeCreateModal}
            onSubmit={this.handleSubmit}
            loading={loading}
            usedTaxRateNames={usedTaxRateNames}
            handleSaveAndAssignSitesClick={this.handleSaveAndAssignSitesClick}
          />
          <AssignSitesModal
            isOpen={showAssignSitesModal}
            onClose={this.closeAssignSitesModal}
            onSubmit={this.handleAssignSitesSubmit}
            rowData={selectedRow}
            handleAssignSitesBackClick={this.handleAssignSitesBackClick}
          />
          <YesNoDialog
            showDialog={isDeleteModalOpen}
            title={`Delete Tax Rate`}
            question={
              selectedRow && selectedRow.Sites && selectedRow.Sites.length > 0
                ? deleteTaxRateWithSitesQuestion
                : deleteTaxRateWithoutSitesQuestion
            }
            yesCallback={() => this.handleDelete(selectedRow)}
            noCallback={() => this.closeDeleteModal()}
            loading={loading}
          />
          <YesNoDialog
            showDialog={showCloseConfirmation}
            title={`Un-Saved Changes Detected`}
            question={`Are you sure you want to close this window and lose any unsaved changes?`}
            yesCallback={this.handleUnSavedChangesDialogYesClick}
            noCallback={this.handleUnSavedChangesDialogNoClick}
          />
          <YesNoDialog
            showDialog={showAssignSitesDialog}
            title={'Overwrite Site Tax Rates'}
            question={`Site(s) ${alreadyAssignedSites} already have tax rates assigned to them. Do you wish to overwite these tax rates?`}
            yesCallback={this.handleAssignSitesDialogYesClick}
            noCallback={this.handleAssignSitesDialogNoClick}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { taxRates } = state.ControlInformationState;
  if (!taxRates)
    return {
      selectedRow: null,
      data: [],
      loading: false,
      error: false,
    };

  return {
    selectedRow: null,
    data: selectors.getReducedTaxRateData(state),
    loading: taxRates.loading,
    error: taxRates.error,
    taxRateSaveSitesSuccessful: selectors.getSaveSitesSuccessful(state),
    getGetSitesError: selectors.getGetSitesError(state),
    saveSitesError: selectors.getSaveSitesError(state),
    taxRateSaveSuccessful: selectors.getSaveSuccessful(state),
    deleteSuccessful: selectors.getDeleteSuccessful(state),
    usedTaxRateNames: selectors.getUsedTaxRateNames(state),
    isTaxRateFormValid: isValid(TAX_RATE_ENTRY_FORM_NAME)(state),
    allSitesWithAssignedTaxRates: selectors.getAllSitesWithAssignedTaxRates(
      state
    ),
    assignSitesFormValues: getFormValues(ASSIGN_TAX_SITES_FORM_NAME)(state),
  };
};

const mapDispatchToProps = {
  getTaxRates: Actions.getTaxRateSetup,
  deleteTaxRate: Actions.deleteTaxRate,
  saveTaxRate: Actions.saveTaxRate,
  saveTaxRateSites: Actions.saveTaxRateSites,
  setSaveSitesSuccessful: Actions.setSaveSitesSuccessful,
  setSaveSuccessful: Actions.setSaveSuccessful,
  setDeleteSuccessful: Actions.setDeleteSuccessful,
  submit,
};

export const TaxRateSetup = connect(
  mapStateToProps,
  mapDispatchToProps
)(TaxRateSetupComponent);



// WEBPACK FOOTER //
// ./src/pages/controlinformation/components/taxRates/TaxRateSetup.js